import { constants, typographyStyles } from "@newsela/angelou";
import type { CSSObject } from "@emotion/react";
const { fontFamily, fontSize } = typographyStyles;
const grey = constants.colors.ui.neutral[100];
const white = constants.colors.ui.white[700];

export const modalCss: CSSObject = {
  root: {
    zIndex: 13,
  },
};

export const modalWrapperCss: CSSObject = {
  backgroundColor: white,
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  height: "580px",
  justifyContent: "space-between",
  maxHeight: "100%",
  maxWidth: "100%",
  overflowY: "auto",
  width: "650px",
};

export const modalHeaderCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  padding: "5px 20px 5px 20px",
  borderBottom: `1px solid ${grey}`,
};

export const modalTitleCss: CSSObject = {
  ...fontFamily.noto,
  ...fontSize.heading4,
};

export const modalBodyCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  padding: "15px 20px",
  width: "100%",
};

export const modalFooterCss: CSSObject = {
  borderTop: `1px solid ${grey}`,
  display: "flex",
  gap: "15px",
  justifyContent: "flex-end",
  padding: "15px",
  width: "100%",
};

export const datePickerContainerCss = {
  display: "flex",
  gap: "15px",
};

export const datePickerCss = {
  PopOut: {
    root: {
      background: "white",
      zIndex: 14,
    },
  },
};

export const datePickerMessageCss: CSSObject = {
  alignItems: "center",
  display: "flex",
  height: "100%",
  justifyContent: "center",
  margin: "0 auto",
  maxWidth: "50%",
  textAlign: "center",
};
